<template>
  <header class="border-bottom border-purple-blue mb-0">
    <img
      v-if="showPixel"
      height="1"
      width="1"
      style="border-style: none"
      alt=""
      src="https://insight.adsrvr.org/track/pxl/?adv=pzdunu8&ct=0:xtknu9t&fmt=3"
    />
    <b-navbar class="pt-3 text-grey" toggleable="lg" variant="white">
      <b-navbar-brand :to="{ name: 'home' }">
        <img src="@/assets/img/logos/CANAM4.png" width="120px" height="auto" />
        <!--   <img
          src="@/assets/img/logos/multi-auto.jpg"
          width="60px"
          height="auto"
        /> -->
      </b-navbar-brand>
      <Notifications />
      <b-nav-item
        v-if="isMobile"
        :active="$route.name && $route.name.includes('inventory.vehicles')"
        :to="{ name: 'inventory.vehicles' }"
      >
        <b-button variant="purple-blue" class="btn btn-lg">
          <span class="text-white"> Buy now! </span>
        </b-button>
      </b-nav-item>

      <!--       
         style=""
          v-if="witdhResponsive === '100%'"
 -->
      <a
        v-if="false"
        href="tel: +1 833 396 1906"
        id="tooltip-canam-contact-number-mobile"
        style="margin-left: 80px"
      >
        <img
          src="@/assets/img/icons/phone.png"
          class="img-responsive"
          style="max-width: 30px"
        />
      </a>

      <b-tooltip target="tooltip-canam-contact-number-mobile" triggers="hover">
        <a href="tel: +1 833 396 1906" style="color: white">
          <b>Contact Phone Number</b>
          <h5 class="mt-2">+1 833 396 1906</h5>
          Tap to call
        </a>
      </b-tooltip>

      <b-nav class="w-100 d-none d-lg-inline-flex" pills align="end">
        <template v-if="userIsClient || userIsBuyer">
          <b-nav-item
            v-for="link in filterLinks"
            v-bind:key="link.routeName"
            :disabled="link.isDisabled || !userHasCompany"
            :active="$route.name && $route.name.includes(link.includesActive)"
            :to="{ name: link.routeName }"
          >
            <span class="text-grey">
              {{ link.display }}
            </span>
          </b-nav-item>
        </template>
        <template v-else>
          <b-nav-item
            v-for="link in filterLinks"
            v-bind:key="link.routeName"
            :disabled="link.isDisabled"
            :active="$route.name && $route.name.includes(link.includesActive)"
            :to="{ name: link.routeName }"
            class="pt-0"
          >
            <b-button variant="purple-blue btn-lg mt-0">
              <span class="text-white">
                {{ link.display }}
              </span>
            </b-button>
          </b-nav-item>
        </template>

        <div v-if="!this.profile">
          <!-- Login button -->
          <b-button
            variant="none"
            class="btn btn-success btn-lg ml-3"
            @click="login"
          >
            <span class="mr-3 ml-3">
              <b-icon icon="box-arrow-in-right" variant="white" class="mr-1" />
              Log In
            </span>
          </b-button>

          <b-button
            variant="none"
            class="btn btn-outline-blue btn-lg ml-3"
            @click="goToRegister()"
          >
            <span class="mr-3 ml-3"> Register </span>
          </b-button>
        </div>
        <!-- Logout button -->
        <b-button
          v-else
          variant="none"
          class="btn btn-outline-danger btn-lg ml-3"
          @click="logout"
        >
          <span class="">Logout</span>
        </b-button>
        <!-- Contact phone number -->
        <a
          href="tel: +1 833 396 1906"
          id="tooltip-canam-contact-number-desktop"
          @click="waitToPixel()"
        >
          <img
            src="@/assets/img/icons/phone.png"
            class="img-responsive ml-3 mt-2"
            style="max-width: 30px"
          />
        </a>
        <b-tooltip
          target="tooltip-canam-contact-number-desktop"
          triggers="hover"
        >
          <b>Contact Phone Number</b>
          <br />
          <a href="tel: +1 833 396 1906" style="color: white">
            +1 833 396 1906
          </a>
        </b-tooltip>
      </b-nav>
      <b-navbar-toggle target="none" v-b-toggle.sidebar-menu> </b-navbar-toggle>
    </b-navbar>
    <b-sidebar
      id="sidebar-menu"
      :width="widthSidebar"
      title=""
      bg-variant="white"
      text-variant="black"
    >
      <template v-slot:title v-if="profile">
        <img
          src="@/assets/img/logos/CANAM4.png"
          width="25%"
          height="auto"
          class="image-responsive"
        />
      </template>

      <b-nav vertical class="text-center text-light">
        <div v-if="userIsClient || userIsBuyer">
          <b-nav-item
            v-for="link in filterLinks"
            v-bind:key="link.routeName"
            :disabled="link.isDisabled || companyIsPending"
            :active="$route.name && $route.name.includes(link.includesActive)"
            :to="{ name: link.routeName }"
          >
            <hr />
            <b-row>
              <b-col class="p-4">
                <span class="text-purple-blue">
                  {{ link.display }}
                </span>
              </b-col>
            </b-row>
          </b-nav-item>
        </div>
        <div v-else>
          <b-nav-item
            v-for="link in filterLinks"
            v-bind:key="link.routeName"
            :disabled="link.isDisabled"
            :active="$route.name && $route.name.includes(link.includesActive)"
            :to="{ name: link.routeName }"
          >
            <hr />
            <b-row>
              <b-col class="p-4">
                <span class="text-purple-blue">
                  {{ link.display }}
                </span>
              </b-col>
            </b-row>
          </b-nav-item>
        </div>
      </b-nav>

      <b-container v-if="!profile" fluid class="text-center mt-2 p-4">
        <LoginForm />
      </b-container>

      <template v-slot:footer>
        <div
          v-if="profile"
          class="d-flex bg-white text-light justify-content-between align-items-center px-3 py-2"
        >
          <!-- Logout button -->
          <b-button variant="outline-danger" size="lg" block @click="logout">
            <span class="">Logout</span>
          </b-button>
        </div>
      </template>
    </b-sidebar>
    <Login />
  </header>
</template>

<script>
import { mapState } from "vuex";
import appRoles from "../helpers/appRoles";
import Login from "@/modules/auth/login/LoginModal";
import LoginForm from "@/modules/auth/login/LoginForm";
import { AUTH_LOGOUT } from "@/modules/auth/login/actions";
import { generalMixin } from "@/modules/mixin.js";
import Notifications from "@/modules/shared/Notifications.vue";
export default {
  components: { Login, LoginForm, Notifications },
  mixins: [generalMixin],
  data() {
    return {
      unAuthenticatedUsersLink: [
        {
          display: "View Inventory, Buy now!",
          routeName: "inventory.vehicles",
          includesActive: "View Inventory",
        },
      ],
      superAdminLinks: [
        {
          display: "View Inventory",
          routeName: "admin.vehicles.list",
          includesActive: "View Inventory",
        },

        {
          display: "Users",
          routeName: "admin.assign-company",
          includesActive: "Users",
        },
      ],
      adminLinks: [
        {
          display: "View Inventory",
          routeName: "admin.vehicles.list",
          includesActive: "View Inventory",
        },

        {
          display: "Users",
          routeName: "admin.assign-company",
          includesActive: "Users",
        },
      ],
      companyLinks: [],
      clientLinks: [
        {
          display: "View Inventory",
          routeName: "client.car-list",
          includesActive: "View Inventory",
        },
        {
          display: "Users",
          routeName: "buyer.users",
          includesActive: "Users",
        },
      ],

      buyerLinks: [
        {
          display: "View Inventory",
          routeName: "buyer.car-list",
          includesActive: "View Inventory",
        },
      ],
      agentLinks: [
        {
          display: "View Inventory",
          routeName: "agent.vehicles.list",
          includesActive: "View Inventory",
        },
      ],
      reviewerLinks: [
        {
          display: "Users",
          routeName: "admin.assign-company",
          includesActive: "Users",
        },
      ],
      trackingLinks: [],
      showPixel: false,
    };
  },
  computed: {
    widthSidebar() {
      return this.$vssWidth > 1280
        ? "25%"
        : this.$vssWidth <= 576
        ? "100%"
        : "50%";
    },
    ...mapState({
      profile: (state) => state.auth.loginStore.profile.data,
    }),
    filterLinks() {
      let links = [];
      if (this.profile && this.profile.user.roles.length) {
        const [superAdmin, admin, buyer, client, agent, reviewer] = appRoles;

        this.profile.user.roles.forEach((value, index) => {
          switch (this.profile.user.roles[index].name) {
            case superAdmin.authority:
              links.push(...this.superAdminLinks); // Add super admin links
              break;
            case admin.authority:
              links.push(...this.adminLinks);
              break;
            case buyer.authority:
              links.push(...this.buyerLinks);
              break;
            case client.authority:
              links.push(...this.clientLinks); // Add buyer links
              break;
            case agent.authority:
              links.push(...this.agentLinks); // Add agent links
              break;
            case reviewer.authority:
              links.push(...this.reviewerLinks);
              break;
            default:
              links.push();
          }
        });
      } else {
        links = [...this.unAuthenticatedUsersLink];
      }
      return links;
    },
    isMobile() {
      return this.$vssWidth <= 576 ? true : false;
    },
  },
  methods: {
    login() {
      this.$bvModal.show("login-modal");
    },
    logout() {
      this.$store
        .dispatch(AUTH_LOGOUT)
        .then(() => {
          this.$router.push({ name: "home" });
        })
        .catch(() => {
          this.$root.$bvToast.toast("Error to logout", {
            title: "Error",
            variant: "danger",
          });
        });
    },
    goToRegister() {
      if (this.$route.name !== "buyer.create")
        this.$router.push({ name: "buyer.create" });
    },
    waitToPixel() {
      this.showPixel = true;
      setTimeout(() => {
        this.showPixel = false;
      }, 1000);
    },
  },
};
</script>

<style scoped>
.icon-text {
  font-size: 25px;
}
a:hover {
  text-decoration: none;
  color: grey;
}
.nav-item-color {
  color: grey;
}
.nav-link {
  padding-top: 0;
}
</style>
